import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const duplicateProductFunc = createAsyncThunk(
    "duplicateProduct",
    async ({ id, data = {} }, thunkAPI) => {
        try {
            const response = await api.post(`dashboard/products/${id}/duplicate`, data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

const duplicateProductSlicer = createSlice({
    name: "duplicateProduct",
    initialState: {
        loading: false,
        data: null,
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(duplicateProductFunc.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.apiErrors = {};
            })
            .addCase(duplicateProductFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";
            })
            .addCase(duplicateProductFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
});

export default duplicateProductSlicer.reducer;
